export const SHARED_LOAN_TERM_MENU_ITEMS = [
	{
		label: '30 Years',
		value: '360',
	},
	{
		label: '25 Years',
		value: '300',
	},
	{
		label: '20 Years',
		value: '240',
	},
	{
		label: '15 Years',
		value: '180',
	},
	{
		label: '10 Years',
		value: '120',
	},
]

export const LOAN_TYPE_MENU_ITEMS = [
	{
		label: 'Loan Type',
		value: '',
	},
	{
		label: 'CONV',
		value: 'Conventional',
	},
	{
		label: 'FHA',
		value: 'FHA',
	},
	{
		label: 'USDA',
		value: 'USDA',
	},
	{
		label: 'VA',
		value: 'VA',
	},
]

export const ESCROW_MENU_ITEMS = [
	{
		label: 'Escrow',
		value: '',
	},
	{
		label: 'Taxes and Insurance',
		value: 'Y',
	},
	{
		label: 'No Escrow',
		value: 'N',
	},
]

export const LIEN_TYPE_MENU_ITEMS = [
	{
		label: 'Lien Type',
		value: '',
	},
	{
		label: 'First Lien',
		value: 'First Lien',
	},
	{
		label: 'Subordinate Lien',
		value: 'Second Lien',
	},
]

export const PROPERTY_TYPE_MENU_ITEMS = [
	{
		label: 'Home Type',
		value: '',
	},
	{
		label: 'Single Family',
		value: 'SingleFamily',
	},
	{
		label: 'Multi Family 2-4 Units',
		value: 'MultiFamily',
	},
	{
		label: 'Condo',
		value: 'Condo',
	},
	{
		label: 'Town Home',
		value: 'TownHome',
	},
	{
		label: 'Co-Op',
		value: 'CoOp',
	},
]

export const PROPERTY_OCCUPANCY_MENU_ITEMS = [
	{
		label: 'Property Occupancy',
		value: '',
	},
	{
		label: 'Primary Residence',
		value: 'PrimaryResidence',
	},
	{
		label: 'Second Home',
		value: 'SecondHome',
	},
	{
		label: 'Investor',
		value: 'Investor',
	},
]
